<template>
    <div class="page customers-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="customersMeta">
                    <crud-table hide-create :actions="actions" show-search search-placeholder="ابحث بـ #رقم العميل أو اسمه أو هاتفه أو بريده الإلكتروني" server-pagination :page-count="customersMeta.last_page" :current-page="customersMeta.current_page" :total="customersMeta.total" :per-page="customersMeta.per_page" title="حسابات العملاء" :items="customersItems" :headers="headers" @open="openCustomer" @load="loadMore" @search="searchHandler" @reset="reset" @create="createDialog = true" :export-url="exportUrl" />
                </div>
            </transition>
        </v-container>

    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CrudTable from '@/components/default/crud-table'

export default {
    name: "Customers",
    components: {
        CrudTable,
    },
    data(){
        return {
            loading: false,

            headers: [
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'item_id',
                },
                {
                    text: 'العميل',
                    align: 'start',
                    sortable: false,
                    avatarText: 'name',
                    avatar: true,
                    avatarIcon: 'mdi-account',
                    bordered: true,
                    width: 45,
                    height: 45,
                    // href: 'customerTo',
                    color: 'blue-grey darken-2',
                },
                {
                    text: 'البريد الإلكتروني',
                    value: 'email',
                    align: 'start',
                    sortable: false,
                    ltr: true,
                },
                {
                    text: 'رقم الهاتف',
                    value: 'phoneComputed',
                    align: 'start',
                    sortable: false,
                    ltr: true,
                },
                {
                    text: 'المدينة',
                    value: 'lastCity',
                    align: 'start',
                    sortable: false,
                },
                {
                    text: 'وقت الانضمام',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        ...GlobalComputed,
        customers(){
            return this.$store.state.customersModule.customers;
        },
        categories(){
            return this.$store.state.customersModule.customersCategories;
        },
        customersMeta(){
            return this.$store.state.customersModule.customersMeta;
        },
        customersItems(){
            return this.customers ? this.customers.map(customer=>{
                return {
                    ...customer,
                    item_id: customer.id,
                    customerTo: {name: 'customer', params: {id: customer.id}},
                    phoneComputed: customer.phone_code + customer.phone,
                    lastCity: customer.last_city || '___',
                };
            }) : [];
        },
        actions(){
            return [
                // {name: 'open', text: 'عرض العميل', icon: 'mdi-open-in-new', color: 'primary'},
                // {name: 'edit', text: 'تعديل', icon: 'mdi-square-edit-outline', color: 'text'},
                // {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'red darken-1'}
            ]
        },
        searchQuery(){
            return this.$route.query.search;
        },
        exportUrl(){
            return `${window.apiUrl}/customers/export`;
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        searchQuery(query){
            this.loadData();
        }
    },
    methods: {
        ...GlobalMethods,
        loadData(page=1){
            if (!this.loading){
                this.loading = true;
                const query = this.searchQuery || null;
                this.$store.dispatch('getCustomers', {page, query}).then(response=>{
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل العملاء', 'error');
                })
            }
        },
        loadMore(payload){
            this.loadData(payload.page);
        },
        reset(){
            if (this.searchQuery){
                this.$router.replace({query: {}})
            }
            this.loadData();
        },
        openCustomer(customer){
            this.$router.push({name: 'customer', params: {id: customer.id}});
        },
        searchHandler(search){
            this.$router.replace({query: {search}})
        },
    },
    mounted(){
        this.loadData();
    }
};
</script>
